import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ExternalLinkIcon, ProductIcon, UpgradeIcon } from 'foundations-assets';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { SideNavItem } from 'foundations-components/transitional/components/SideNav';
import { useSelectedView } from '../../hooks/config';
import { trackUserInteraction } from '../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export const BILLING_READ_SCOPES = ['billing-read', 'billing-read-restricted'];
const SetupGuideNavProductItem = ({
  isLoadingTrials,
  showTrialPickerLink,
  hasBillingPermissions
}) => {
  const selectedView = useSelectedView();
  if (isLoadingTrials || !hasBillingPermissions) {
    return null;
  }
  if (showTrialPickerLink) {
    return /*#__PURE__*/_jsx(SideNavItem, {
      "data-test-id": "trial-picker-link",
      external: true,
      href: `/trial-picker/${PortalIdParser.get()}?hub=${selectedView}`,
      iconLeft: /*#__PURE__*/_jsx(IconHolder, {
        icon: UpgradeIcon,
        paddingBlock: "0",
        paddingBlockStart: "50",
        paddingInline: "0",
        size: "400"
      }),
      onClick: () => trackUserInteraction('click trial premium tools link'),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.tabs.trialLink"
      }),
      value: "trial-picker-link"
    });
  }
  return /*#__PURE__*/_jsx(SideNavItem, {
    "data-test-id": "products-link",
    href: `/account-and-billing/${PortalIdParser.get()}`,
    iconLeft: /*#__PURE__*/_jsx(IconHolder, {
      icon: ProductIcon,
      paddingBlock: "0",
      paddingBlockStart: "50",
      paddingInline: "0",
      size: "400"
    }),
    iconRight: /*#__PURE__*/_jsx(ExternalLinkIcon, {
      color: "icon-secondary-disabled",
      size: "400"
    }),
    onClick: () => trackUserInteraction('click view your plan link'),
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.tabs.productsLink"
    }),
    value: "products-link"
  });
};
export default SetupGuideNavProductItem;